<template>
  <section class="features" id="features">
    <div class="container">
      <h2>Designed for Musicians, Powered by Simplicity</h2>
      <div class="feature-grid">
        <div class="feature-item" v-for="feature in features" :key="feature.title">
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {

  data() {
    return {
      features: [
        { title: "Control Room", description: "Alle deine Gigs auf einen Blick, damit du nie die Kontrolle verlierst" },
        { title: "Booking Area", description: "Erstelle schnell und einfach Email-Kampagne für Live, Radio und Print" },
        { title: "Video Tips", description: "Tips und Tricks für erfolgreiche Bookings" },
      ],
    };
  },
};
</script>

<style scoped>
.features {
 background: url('../assets/features-background.jpg') no-repeat center center;
  background-size: cover;
  position: relative;
  color: var(--text-color);
}

.features::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Overlay with 50% opacity */
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2; /* Ensures text is above the overlay */
  text-align: center;
  padding-top: 10rem;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.feature-item {
  background: rgba(159, 153, 153, 0.8); /* Semi-transparent white */
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(216, 148, 148, 0.1);
  color: var(--secondary-color);
}
.feature-item h3 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
  color: var(--main-color); /* Neon pink for titles */
}
h1, h2, h3 {
  color: var(--text-color);
}

@media (max-width: 480px) {
  .container {
    padding-top: 2rem; /* Reduce padding on smaller devices */
  }

  .feature-grid {
    grid-template-columns: 1fr; /* Single-column layout */
    gap: 1rem;
  }

  .feature-item {
    padding: 1rem;
  }

  .feature-item h3 {
    font-size: 1rem;
  }
}


</style>
